import { render, staticRenderFns } from "./specialties.datatable.vue?vue&type=template&id=001db570&"
import script from "./specialties.datatable.vue?vue&type=script&lang=js&"
export * from "./specialties.datatable.vue?vue&type=script&lang=js&"
import style0 from "./specialties.datatable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
